import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import { useNavigate } from 'react-router-dom';
import { ConditionalLink } from 'components/ConditionalLink';
import { getCreateDealRoute } from 'utils';
import ListingContext from '../../../../providers/Listing/Listing.context';
import NoListingCard from 'assets/images/NoListingCard.webp';
import ShineIcon from 'icons/Shine.icon';

import './MarketYourDeal.styles.scss';

export const BUTTON_CLASSES = 'as-button ncoded-button ncoded-button--outline';

type MarketYourDealProps = {
  className?: string;
};

const MarketYourDeal: React.FC<MarketYourDealProps> = (props) => {
  const { className } = props;

  const {
    dealRoom: { _id: dealId },
    areActionsDisabled,
  } = useContext(ListingContext);

  const classes = classNames(
    'market-your-deal',
    { disabled: areActionsDisabled },
    className,
  );

  const listingUrl = getCreateDealRoute(dealId, true, 'market-listing');

  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    if (areActionsDisabled) return;
    navigate(listingUrl);
  }, [areActionsDisabled, listingUrl, navigate]);

  const { t } = useTranslation();

  return (
    <div className={classes} onClick={handleOnClick}>
      <div className="card-heading">
        <p>{t('marketThisDealWithListing')}</p>
        <p>{t('targetOurNetworkOfQualifiedBuyers')}</p>
      </div>

      <ResolveImage src={NoListingCard} asIllustration />

      <ConditionalLink
        isDisabled={areActionsDisabled}
        disabledClassName={BUTTON_CLASSES}
        linkClassName={BUTTON_CLASSES}
        to={listingUrl}
      >
        {t('createAListing')}
        <ShineIcon />
      </ConditionalLink>
    </div>
  );
};
export default MarketYourDeal;
